import { createSelector } from '@reduxjs/toolkit'

export const settings = ({ settings }) => settings

export const folderIdSelector = createSelector(
  settings,
  ({ folder_id }) => folder_id
)

export const activeEntryGuidSelector = createSelector(
  settings,
  ({ activeEntry }) => activeEntry
)

export const activeSheetIdSelector = createSelector(
  settings,
  ({ activeSheet }) => activeSheet
)

export const unsavedChangesSelector = createSelector(
  settings,
  ({ unsavedChanges }) => unsavedChanges || false
)

export const isFormSavingSelector = createSelector(
  settings,
  ({ isAppSaving }) => isAppSaving
)

export const flashMessageSelector = createSelector(
  settings,
  ({ flashMessage }) => flashMessage
)

export const activeModalNameSelector = createSelector(
  settings,
  ({ activeModal }) => activeModal
)

export const saveAndPublishLoadedSelector = createSelector(
  settings,
  ({ loaded }) => loaded
)

export const sendNotificationSelector = createSelector(
  settings,
  ({ send_notification }) => send_notification
)

export const usersSelector = createSelector(settings, ({ users }) => users)

export const groupsSelector = createSelector(settings, ({ groups }) => groups)

export const assignedUsersSelector = createSelector(
  settings,
  ({ assignedUsers }) => assignedUsers
)

export const assignedGroupsSelector = createSelector(
  settings,
  ({ assignedGroups }) => assignedGroups
)

export const whiteLabelSelector = createSelector(
  settings,
  ({ whiteLabeled }) => whiteLabeled
)
